import axios from "axios";
export default {
  state: {

  },
  getters: {

  },
  mutations: {

  },
  actions: {
    async createAssessment( _, data){
      return await axios.post('/superadmin/assessments', data)
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(errors => {
        return Promise.reject(errors.response)
      })
    }
  },
};
